<template>
  <dv-border-box-1 >
      <div class="box-container">
          <div class="title">{{ title }}</div>
          <div class="content">
            <slot></slot>
          </div>
      </div>
  </dv-border-box-1>
</template>

<script>
export default {
  name: 'BoxContainer',
  data () {
    return {
    }
  },
  props: {
    title: String
  }
}
</script>

<style lang="less">

.box-container {
    margin: 10px;
    width: calc(~"100% - 20px");
    height: calc(~"100% - 20px");
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(6, 30, 93, 0.5);
    border-radius: 20px;

    .title {
        padding: 10px 0%;
        height: 30px;
        line-height: 30px;
        font-size: 20px;
    }

    .content {
        width: calc(~"100% - 40px");
        height: calc(~"100% - 60px");
    }
}
</style>
